function analyticsReducer({ analyticsActionName }) {
    const initialState = [];

    return function reducer(state = initialState, action) {
        if (
            action.type === 'LOGOUT_REQUEST' ||
            action.type === 'AUTHENTICATE_REQUEST' ||
            action.type === `${analyticsActionName}_REQUEST` ||
            action.type === `${analyticsActionName}_RESET`
        ) {
            return initialState;
        }

        if (action.type === `${analyticsActionName}_SUCCESS`) {
            return action.payload;
        }

        return state;
    };
}

export default analyticsReducer;
